import { useEffect } from "react";
import Lenis from "lenis";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Manifesto from "@/components/landing/Manifesto";
import Features from "@/components/landing/Features";
import About from "@/components/landing/About";
import Ribbon from "@/components/landing/Ribbon";
import Socials from "@/components/landing/Socials";
import Download from "@/components/landing/Download";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -20 });
        }
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <Features />
        <About />
        <Ribbon />
        <Socials />
        <Download />
      </main>
      <Footer />
    </div>
  );
}
